import { Actions as ChatActions } from "./actions";
import { Actions as AuthActions } from "../auth/actions";
import { applyLastMessage, applyReadSeq } from "@src/views/chat/utils";

const initialState = {
  // Chats with anything unread
  unreadCount: 0,
  // conversationId -> { lastSeq, lastReadSeq, unreadCount }
  conversations: {},
};

// The badge counts chats with something unread, not the messages in them
const withTotal = (conversations) => ({
  conversations,
  unreadCount: Object.values(conversations).filter((c) => c.unreadCount > 0).length,
});

const chatReducer = (state = initialState, action) => {
  switch (action.type) {
    case ChatActions.SET_UNREAD:
      return withTotal(
        Object.fromEntries(
          action.conversations.map((c) => [
            c.id,
            { ...c, unreadCount: c.unreadCount ?? Math.max(c.lastSeq - c.lastReadSeq, 0) },
          ])
        )
      );
    case ChatActions.CONVERSATION_UPDATED: {
      const conversation = state.conversations[action.conversationId];
      if (!conversation) return state;
      return withTotal({
        ...state.conversations,
        [action.conversationId]: applyLastMessage(conversation, action.lastMessage, action.currentStaffId),
      });
    }
    case ChatActions.READ_UPDATED: {
      const conversation = state.conversations[action.conversationId];
      if (!conversation) return state;
      return withTotal({
        ...state.conversations,
        [action.conversationId]: applyReadSeq(conversation, action.lastReadSeq),
      });
    }
    // The next person to log in never sees this one's counts
    case AuthActions.LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default chatReducer;
